const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", documentHeight);
documentHeight();
// Snipet mm-sous-collection-block

// ZOOM
function sliderVideoZoomIn(e, classSlider) {
    var slider = document.querySelector(classSlider);
    var mmVideos = slider.querySelectorAll(".mm-video");

    slider.classList.add("mm-zoom-in");

    mmBgNav(classSlider);
    mmVideos[0].play();
    e = e || window.event;
    e.preventDefault();
}

function sliderVideoZoomOut(classSlider) {
    goToFirstSlide(classSlider);

    var slider = document.querySelector(classSlider);

    slider.classList.remove("mm-zoom-in");

    var mmVideos = slider.querySelectorAll(".mm-video");
    mmVideos.forEach(function (mmVideo) {
        mmVideo.pause();
        mmVideo.currentTime = 0;
    });
}
// NEXT SLIDE
function goToNextSlide(classSlider) {
    var slider = document.querySelector(classSlider);
    var currentBullet = slider.querySelector(".splide__pagination__page.is-active");
    var nextBullet = currentBullet.closest("li").nextSibling;

    if (nextBullet) {
        nextBullet.firstChild.click();
    } else {
        goToFirstSlide(classSlider);
        sliderVideoZoomOut(classSlider);
    }
    // var mmVideos = slider.querySelectorAll('.mm-video');
    // mmVideos.forEach(function(mmVideo){
    //   mmVideo.pause();
    //   mmVideo.currentTime = 0;
    // })

    // var mmSlide = slider.querySelector('.mm-slide-video-slide.is-next');
    // if (mmSlide) {
    //   var mmVideo = mmSlide.querySelector('.mm-video');
    //   mmVideo.play();
    // }
}

// FIRST SLIDE
function goToFirstSlide(classSlider) {
    var slider = document.querySelector(classSlider);
    var firstBullet = slider.querySelector(".splide__pagination > li:first-child > button");

    firstBullet.click();
}

// BG NAV
function mmBgNav(classSlider) {
    var slider = document.querySelector(classSlider);
    var bullets = slider.querySelectorAll(".splide__pagination__page");

    bullets.forEach(function (bullet) {
        bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 50%)";
    });

    if (window.innerWidth < 768) {
        Array.from(bullets).every(function (bullet) {
            bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%)";
            if (bullet.classList.contains("is-active")) {
                return false;
            } else {
                return true;
            }
        });
    } else {
        bullets.forEach(function (bullet) {
            bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%)";
            if (bullet.classList.contains("is-active")) {
                // throw BreakError;
            }
        });
    }
}

//Header

function mmMobileMenu() {
    var mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

    mobileMenu.classList.toggle("mm-menu-open");
    document.querySelector("html").classList.toggle("stop-scrolling");
}

function mmMobileAcc(className) {
    var classElem = document.querySelector(className);

    classElem.classList.toggle("mm-menu-open");
}

/* DROPDOWN MOBILE */
function mmMobileDropdown(className) {
    var menuTitle = document.getElementsByClassName(className);
    var menuLink = menuTitle[0].nextElementSibling;
    var arrowReverse = document.getElementsByClassName(className.firstChild);

    menuLink.classList.toggle("header-active");
    if (arrowReverse) {
      arrowReverse.classList.toggle("mm-arrow-reverse");
    }
}


/* Dropdown */
/* dropdown active par default */
function animatedDropdowns(){
  const faqColl = document.querySelectorAll('.mm-accordion');
  console.log(faqColl);

  let q;

  for (q = 0; q < faqColl.length; q++) {
      faqColl[q].addEventListener('click', function () {
          const content = this.nextElementSibling;
          let contentHeight = content.clientHeight;

          if (contentHeight > 0) {
            content.style.maxHeight = 0;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }

          this.classList.toggle("active");
      });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  animatedDropdowns();
});

if (window.innerWidth < 900) {
  document.addEventListener("DOMContentLoaded", function () {
    let summaries = document.querySelectorAll(".accordion summary");

    if (summaries) {
      summaries.forEach((summary) => {
        summary.addEventListener("click", function () {
          setTimeout(() => {
            var parentPanel = this.closest(".mm-pf-panel");
            if (parentPanel) {
              parentPanel.style.maxHeight = parentPanel.scrollHeight + "px";
            }
          }, 0); // Timeout pour laisser le `<details>` s'ouvrir
        });
      });
    }
  });
}
